import { CanDeactivateFn } from '@angular/router';
import { ComponentCanDeactivate } from './component-can-deactivate';

export const hasUnsavedChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = async (component: ComponentCanDeactivate, currentRoute, currentState, nextState) => {
  const canDeactivate = component.canDeactivate();

  if (!canDeactivate) {
    if(confirm(component.getLeavingConfirmationMessage())) {
      component.closeOpenDialogs();
      await component.saveDataBeforeDeactivation();
      return true;
    }
    return false;
  }
  
  component.closeOpenDialogs();
  await component.saveDataBeforeDeactivation();
  return true;
};